import React from 'react'
import { Helmet } from 'react-helmet'

interface IHelmet {
  title: string
  description: string
  url: string
  language: string
  image?: string
}

const EN_ROUTE_INDICATOR = '/en'
const FR_ROUTE_INDICATOR = '/fr'
const ARTICLE_PATH = '/actualites/article/'

const buildAlternateURLs = (url, language) => {
  if (url.indexOf(ARTICLE_PATH) !== -1) {
    return []
  }

  let enURL = language === 'fr' ? url.replace(FR_ROUTE_INDICATOR, EN_ROUTE_INDICATOR) : url
  let frURL = language === 'fr' ? url : url.replace(EN_ROUTE_INDICATOR, FR_ROUTE_INDICATOR)

  if (document.location.pathname === '/') {
    if (/[?]/.test(url)) {
      const splitedUrl = url.split('?')
      const basePath = splitedUrl[0]
      const urlParam = splitedUrl[1]
      frURL = `${basePath}fr/?${urlParam}`
      enURL = `${basePath}en/?${urlParam}`
    } else {
      frURL = `${url}fr`
      enURL = `${url}en`
    }
  }

  return [
    { href: frURL, local: 'fr' },
    { href: enURL, local: 'en' }
  ]
}

export const HelmetTemplate = ({ title, description, image, language, url }: IHelmet) => {
  const alternateUrls = buildAlternateURLs(url, language)

  return (
    <Helmet htmlAttributes={{ lang: language }}>
      <title>{title}</title>

      {alternateUrls.map(({ href, local }) => (
        <link rel="alternate" href={href} hrefLang={local} key={local} />
      ))}

      <meta name="description" content={description}></meta>
      <meta name="title" content={title}></meta>
      <meta property="og:title" content={title}></meta>
      <meta property="og:description" content={description}></meta>
      <meta property="og:url" content={url}></meta>
      <meta property="og:site_name" content="iliad"></meta>
      <meta property="og:image" content={image}></meta>
      <meta property="og:image:width" content="600"></meta>
      <meta property="og:image:height" content="400"></meta>

      <meta property="twitter:title" content={title}></meta>
      <meta property="twitter:description" content={description}></meta>
      <meta property="twitter:site" content="Iliad"></meta>
      <meta property="twitter:site:id" content="252263949"></meta>
      <meta property="twitter:creator" content="Iliad"></meta>
      <meta property="twitter:creator:id" content="20043364"></meta>
      <meta property="twitter:card" content="summary_large_image"></meta>
      <meta property="twitter:image:src" content={image}></meta>
      <meta property="twitter:image:width" content="600"></meta>
      <meta property="twitter:image:height" content="400"></meta>

      <script type="text/javascript" src="/clarity.js" />
    </Helmet>
  )
}
